import { config } from "../../constants/constant";

export const aggregatorEndpoints = {
  DOCUMENT_TYPE_LIST: config.BASE_URI + "/api/v2/document_type",
  ADVANCE_SEARCH_ENDPOINT: config.BASE_URI + "/secure/api/v1/admin/approved_template_search"
};
